import { createAction } from '@reduxjs/toolkit'

export const validateFormAction = createAction('validateForm', (formKey) => ({
  payload: formKey,
}))
